import { Component, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModalInfoOkComponent } from 'src/app/shared/components/modals/info-ok/modal-info-ok.component';
import { SimpleQueryResponse } from 'src/app/shared/dtos/simpleQueryResponse';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';
import { ReferentielComponentsService } from '../referentiel-components.service';
import { RegionModel } from 'src/app/shared/models/rsa/region.model';
import { RegionService } from 'src/app/shared/services/rsa/region.service';
import { UntypedFormGroup } from '@angular/forms';
import { ModalAddRegionComponent } from 'src/app/shared/components/modals/modal-add-region/modal-add-region.component';

@Component({
  selector: 'app-gestion-region',
  templateUrl: './gestion-region.component.html',
  styleUrls: ['./gestion-region.component.scss']
})
export class GestionRegionComponent implements OnInit {
  regions: RegionModel[] = [];
  displayedColumns: string[] = ['code', 'libelle', 'active', 'action'];
  dataSource: RegionModel[];
  matDataSource = new MatTableDataSource<RegionModel>();
  sortState: Sort = {active: 'Code', direction: 'desc'};
  length: number;
  pageSize = 25;
  pageEvent: PageEvent;
  result: boolean;
  objet: SimpleQueryUser = new SimpleQueryUser();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(public router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private toastrService: ToastrService,
    private regionService: RegionService,
    private gestionReferentielComponent: ReferentielComponentsService
    ) { }

  ngOnInit(): void {
    this.objet.query = '';
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.objet.order = 'Code';
    this.matDataSource.paginator = this.paginator;
    this.loadPage();
  }

  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateRegionFormGroup();
    this.openModal(form);
  }

  onModify(region: RegionModel): void {
    const form = this.gestionReferentielComponent.getEditRegionFormGroup(region);
    this.openModal(form);
  }

  openModal(form: UntypedFormGroup): void{
    const dialogRef = this.dialog.open(ModalAddRegionComponent, {
      autoFocus: false,
      disableClose: true,
      data: {
        form,
        result: this.result
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadPage();
      }
    });
  }


  onDelete(region: RegionModel): void {
    var message = this.getAgencesActive(region);
    if(message !== ""){
      const dialogRef = this.dialog.open(ModalInfoOkComponent, {
        data: {
          title: 'Impossible de désactiver cette région car les agences suivantes sont actives',
          message: message,
          icone: 'warning_amber',
          iconColor: 'accent',
          color: 'accent'
        }
      });
    }else {
      const dialogRef = this.dialog.open(ModalInfoOkComponent, {
        data: {
          title: 'désactivation de la région ' + region.libelle,
          message: 'Êtes-vous sur de vouloir désactiver la région ?',
          icone: 'warning_amber',
          iconColor: 'accent',
          color: 'accent'
        }
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res) {
          this.regionService.desactivation(region.id, region).subscribe((response: RegionModel) => {
            this.toastrService.success('La region a bien été désactivé');
            this.loadPage();
          });
        }
      });
    }
    
  }

  getAgencesActive(region: RegionModel): string{
    var agencesActive = "";
    for (const agence of region.agences) {
      if(!agence.dDesactivation){
        agencesActive += agence.libelle + ", "
      }
    }
    return agencesActive;
  }


  orderUsers(regions: RegionModel[]): RegionModel[] {
    regions = regions.sort((a, b) => {
      if (a.code) {
        return a.code.localeCompare(b.code);
      } else {
        return -1;
      }
    });
    return regions;
  }

  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    var referentiel = new SimpleQueryUser();
    referentiel = this.objet;
    this.regionService.loadFromSimpleQueryRef(referentiel).subscribe((query: SimpleQueryResponse<RegionModel>) => {
      if (query.objets != null) {
        this.regions = query.objets;
      } else {
        this.regions = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<RegionModel>(this.regions);
      this.paginator.length = this.length;
    });
  }

  close(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }

}

